import { render, staticRenderFns } from "./Dependent.vue?vue&type=template&id=c212d0be&scoped=true"
import script from "./Dependent.vue?vue&type=script&lang=js"
export * from "./Dependent.vue?vue&type=script&lang=js"
import style0 from "./Dependent.vue?vue&type=style&index=0&id=c212d0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c212d0be",
  null
  
)

export default component.exports